import React, { useState } from "react";
import IconCheckbox from "../../../ShareElements/IconCheckbox/IconCheckbox";
import Switch from "../../../ShareElements/TextInput/Switch";

const ACLMappingAddedRowItem = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);

  const toggleDelete = () => {
    let Index = props.PageData.length + props.Index;
    props.ShowDeleteAlert(Index, props.NewItem.id, true);
    setModalIsOpen(false);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleScopeChange = () => {
    props.EnableSave();
    document
      .getElementById(
        "Scope-" + (props.Index + props.PageData.length) + "-holder"
      )
      .classList.remove("cx-select-error-is-shown");
  };

  const handleACLChange = () => {
    props.EnableSave();
    document
      .getElementById(
        "ACL-" + (props.Index + props.PageData.length) + "-holder"
      )
      .classList.remove("cx-select-error-is-shown");
  };

  return (
    <div className="form-row" key={props.Key}>
      <div
        className="xlarge select-holder"
        id={"Scope-" + (props.Index + props.PageData.length) + "-holder"}
      >
        <select
          id={"Scope-" + (props.Index + props.PageData.length) + "-filter"}
          onChange={() => handleScopeChange()}
        >
          <option value={props.NewItem.scopeId}>
            {props.NewItem.preselectedScopeName !== ""
              ? props.NewItem.preselectedScopeName
              : translateText("not_specified")}
          </option>
          {props.Scopes.map((Scope) => (
            <React.Fragment>
              {props.NewItem.preselectedScopeName === Scope.name ? null : (
                <option key={Scope.id} value={Scope.id}>
                  {Scope.name}
                </option>
              )}
            </React.Fragment>
          ))}
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
        <p className="field-error-message">{props.SectionErrorText}</p>
      </div>
      <div
        className="xlarge select-holder"
        id={"ACL-" + (props.Index + props.PageData.length) + "-holder"}
      >
        <select
          id={"ACL-" + (props.Index + props.PageData.length) + "-filter"}
          onChange={() => handleACLChange()}
        >
          <option value={props.NewItem.aclId}>
            {props.NewItem.preselectedACLName !== ""
              ? props.NewItem.preselectedACLName
              : translateText("not_specified")}
          </option>
          {props.ACLs.map((ACL) => (
            <React.Fragment>
              {props.NewItem.preselectedACLName === ACL.name ? null : (
                <option key={ACL.id} value={ACL.id}>
                  {ACL.name}
                </option>
              )}
            </React.Fragment>
          ))}
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
        <p className="field-error-message">{props.ACLErrorText}</p>
      </div>
      <div className="large triple">
        <IconCheckbox
          Name={"View-" + parseInt(props.Index + props.PageData.length)}
          ActiveIcon={props.ViewActive}
          IsDefaultActive={props.NewItem.view}
          DeactiveIcon={props.ViewDeactive}
          ChangeHandler={() =>
            props.HandleCheckboxChange(
              "View-",
              parseInt(props.Index + props.PageData.length)
            )
          }
        />
        <IconCheckbox
          Name={"Edit-" + parseInt(props.Index + props.PageData.length)}
          ActiveIcon={props.EditActive}
          IsDefaultActive={props.NewItem.edit}
          DeactiveIcon={props.EditDeactive}
          ChangeHandler={() =>
            props.HandleCheckboxChange(
              "Edit-",
              parseInt(props.Index + props.PageData.length)
            )
          }
        />
        <Switch
          ChangeEvent={() => props.HandleSwitchChange()}
          Id={"status-" + parseInt(props.Index + props.PageData.length)}
          IsActive={props.NewItem.enabled}
          ClassName="less-spaced"
        />
      </div>
      <div className="large menu">
        <button
          onClick={() =>
            props.DuplicateAddedItem(
              props.NewItem,
              props.Index + props.PageData.length
            )
          }
          className="duplicate"
        >
          <i className="feather-copy"></i>
        </button>
        <button onClick={() => setModalIsOpen(true)} className="more"></button>
      </div>
      <div className="more-info">
        <div
          className="modal-space"
          id={"modal-" + parseInt(props.Index + props.PageData.length)}
          style={ModalIsOpen ? { display: "block" } : null}
        >
          <div className="outline" onClick={() => setModalIsOpen(false)}></div>
          <div className="modal-body double-item">
            <button className="btn" onClick={() => toggleDelete()}>
              <img alt="" src={props.DeleteIcon} />
              <div className="btn-text">
                <p>{translateText("delete")}</p>
                <p>{translateText("delete_this_record")}</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ACLMappingAddedRowItem;
